import Box from '@mui/material/Box';
import React, {ReactNode} from 'react';
import {sx} from './sx'
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    children: ReactNode,
    sx?: SxType,
}

const TopSidebarViewSingleVoyage = ({children, sx: sxProps = {}}: IProps) => {
    return (
        <Box
            sx={{
                ...sx.root,
                ...sxProps
            }}
        >
            {children}
        </Box>
    );
};

export default TopSidebarViewSingleVoyage;